import { RECAPTCHA_SUCCESS, RECAPTCHA_ERROR } from '../../actions/actionTypes';

const recaptchaSuccess = (verification) => ({
    type: RECAPTCHA_SUCCESS,
    verification
});

const recaptchaError = () => ({
    type: RECAPTCHA_ERROR
});

export const persistVerification = (verification) => {
    return async (dispatch) => {
        dispatch(recaptchaSuccess(verification));
    }
};

export const expireVerification = () => {
    return async (dispatch) => {
        dispatch(recaptchaError());
    }
};
